<script>
import Layout from "../../../layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import { Modal } from "bootstrap";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";

export default {
  page: {
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
  },
  data() {
    return {
      del: "",
      tickets: [],
      issues: [],
      customers: [],
      Tickets: {},
      page: 1,
      limit: 20,
      tot_pages: 0,
      pageres: 1,
      limitres: 20,

      searchTickets: null,
      TicketsSearchMode: false,
      ticket_resolutions: [],
      TicketResolutions: {},
      emps: [],
      ticket_id: 0,
      searchModel: "",
      searchTicketResolutions: null,
      TicketResolutionsSearchMode: false,
      add_or_edit_modal: {},
      data: {},
      editor: ClassicEditor,
      show: 2,
      editorConfig: {
        // The configuration of the editor.
      },
      editMode: false,
      ticket_modal: {},
      add_ticket_resolution_modal: {},
      customerMode: "existing", // 'existing' or 'new'
      newCustomerName: "", // For manual input of new customer name
      // appprices:[]
    };
  },
  methods: {
    getSwitch(searchIn, remark) {
      console.log("*********", remark);
      this.http
        .put("tickets", searchIn.id, {
          remark: remark,
        })

        .then(() => {
          this.get(this.page);
        });
    },
    closeTicket(searchIn) {
      var data = {
        title: "popups.confirm",
        msg: "popups.closeTicketMsg",
      };
      this.popup.confirm(data).then((resp) => {
        if (resp) {
          this.http
            .put("tickets", searchIn.id, {
              status: 1,
            })

            .then((res) => {
              if (res.status) this.get(this.page);
            });
        }
      });
    },
    gitresolution(searchIn) {
      this.ticket_id = searchIn.id;
      this.data = {};
      this.ticket_modal.show();
      this.http.get("ticket-resolutions/" + searchIn.id).then((res) => {
        this.ticket_resolutions = res.data;
      });
    },

    addTicketResolution() {
      this.data.ticket_id = this.ticket_id;
      console.log("step 94 :", this.data);

      this.http.post("ticket-resolutions", this.data).then((res) => {
        if (res.data) {
          this.add_ticket_resolution_modal.hide();
          this.gitresolution({ id: this.ticket_id });
          this.get(this.page);
        }
      });

      /*    setTimeout(() => {
        document.querySelector(".btn-close").click();
      }, "200"); */

      //  var x = document.getElementsByClassName('modal')
      //  x.classList.remove("modal fade show")
      //  x.classList.add('modal fade hide')

      /*   var data = {
        title: "popups.addticketresolution",
        inputs: [
          {
            model: "emp_id",
            type: "select",
            options: (() => {
              return this.emps.map((type) => {
                return { value: type.id, label: type.name };
              });
            })(),
            label: "popups.employee",
          },

          {
            model: "report",
            type: "ckeditor",
            label: "popups.des",
          },
        ],
        buttons: [
          {
            text: "popups.add",
            closer: true,
            color: "primary",
            handler: (obj) => {
              console.log(this.$route.params.id);
              obj.ticket_id = this.ticket_id;
              // document.querySelector('modal fade show').remove()
              this.http.post("ticket-resolutions", obj).then(() => {
                this.get(this.page);
              });
            },
          },
          {
            text: "popups.cancel",
            closer: true,
            color: "danger",
            handler: () => {
              console.log("Like Clicked");
            },
          },
        ],
      };
      this.popup.modal(data); */
    },
    preAddTicketResolutions() {
      this.ticket_modal.hide();
      this.data = {};

      this.add_ticket_resolution_modal.show();
    },

    addTicket() {
      console.log("step 151 :", this.data);

      this.http.post("tickets", this.data).then((res) => {
        if (res.status) this.get(this.page);
        this.add_or_edit_modal.hide();
      });
    },
    editTicket() {
      console.log("step 151 :", this.data.customer.name);
      if (!this.data?.customer_id && !this.data.customer?.name) {
        return this.popup.alert({
          title: "popups.error",
          msg: "popups.you_need_to_enter_customer_name",
        });
      } else {
        this.http.put("tickets", this.data.id, this.data).then((res) => {
          if (res.status) this.get(this.page);
          this.data = {};
          this.newCustomerName = "";
          this.add_or_edit_modal.hide();
        });
      }

      /*   var data = {
        title: "popups.editticket",
        inputs: [
          {
            model: "issue_type_id",
            type: "select",
            options: (() => {
              return this.issues.map((type) => {
                return { value: type.id, label: type.name };
              });
            })(),
            label: "popups.issuetype",
            value: searchIn.issue_type_id,
          },

          {
            model: "customer_id",
            type: "select",
            options: (() => {
              return this.customers.map((type) => {
                return { value: type.id, label: type.name };
              });
            })(),
            label: "popups.customer",
            value: searchIn.customer_id,
          },
          {
            model: "status",
            type: "select",
            label: "popups.status",
            options: [
              { label: "UnFinished", value: 0 },
              { label: "Finished ", value: 1 },
            ],
          },

          {
            model: "description",
            type: "ckeditor",
            label: "popups.des",
            value: searchIn.description,
          },
          {
            model: "priority",
            type: "select",
            options: [
              { label: "High", value: 1 },
              { label: "medium", value: 2 },
              { label: "low", value: 3 },
            ],
            label: "popups.priority",
            value: searchIn.priority,
          },
        ],
        buttons: [
          {
            text: "popups.edit",
            closer: true,
            color: "primary",
            handler: (obj) => {
              this.http.put("tickets", searchIn.id, obj).then(() => {
                this.get(this.page);
              });
            },
          },
          {
            text: "popups.cancel",
            closer: true,
            color: "danger",
            handler: () => {
              console.log("Like Clicked");
            },
          },
        ],
      };
      this.popup.modal(data); */
    },
    search(page) {
      if (!this.searchModel.length) return this.cancelappsearchMode();
      this.TicketsSearchMode = true;
      this.tot_pages = 0;
      this.http
        .post("tickets/search", {
          search: this.searchModel,
          col: "name",
          limit: this.limit,
          page: this.page,
        })
        .then((res) => {
          this.page = page;
          this.tot_pages = Math.ceil(res.tot / this.limit);
          this.tickets = res.data;
          // console.log('g' );
          // this.tickets = res.data.map(element =>
          // this.tickets = element.tickets,
          // console.log("xxxxxxx",this.tickets)).filter(z=>this.tickets = z.tickets)

          console.log("*********** ticketsbbb", this.tickets);
        });
    },
    cancelappsearchMode() {
      this.searchModel = "";
      this.TicketsSearchMode = false;
      this.get(this.page);
    },

    gitIssue() {
      this.http.get("issue-types").then((res) => {
        this.issues = res.data;
      });
    },
    gitcustomer() {
      this.http.get("customers").then((res) => {
        this.customers = res.data;
      });
    },
    deleteTickets(searchIn) {
      this.popup
        .confirm({
          title: "popups.delete",
          msg: "popups.delmessage",
        })
        .then((resp) => {
          if (resp) {
            this.http.delete("tickets", searchIn.id).then(() => {
              this.get(this.page);
            });
          }
        });
    },

    get(page) {
      console.log(page);
      this.http
        .post("tickets/pagination", {
          limit: this.limit,
          page: page,
        })
        .then((res) => {
          this.page = page;
          this.tot_pages = Math.ceil(res.tot / this.limit);
          this.tickets = res.data;
        });
    },
    preAddTicket() {
      this.editMode = false;

      this.data = {};
      this.add_or_edit_modal.show();
    },
    preEditTicket(record) {
      this.editMode = true;
      console.log(record);

      this.data = JSON.parse(JSON.stringify(record));
      this.add_or_edit_modal.show();
    },
    searchEmployees(search) {
      this.http
        .post(
          "emp-custodies/search-emps",
          {
            search,
            limit: 25,
            // current_emp_id: this.data.under_custody[0]?.emp_id,
          },
          null,
          true
        )
        .then((res) => {
          if (res.status) {
            this.emps = res.data;
          }
        });
    },
    searchCustomers(search) {
      this.http
        .post(
          "customers/search",
          {
            search,
            page: 1,
            limit: 25,
            // current_emp_id: this.data.under_custody[0]?.emp_id,
          },
          null,
          true
        )
        .then((res) => {
          if (res.status) {
            this.customers = res.data;
          }
        });
    },
    showEmpLabel(one) {
      return `${one.id} - ${one.name}`;
    },
    closeAddTicketModel() {
      this.add_or_edit_modal.hide();
    },
  },

  created() {
    this.get(1);

    this.gitIssue();
    // this.gitcustomer();
  },
  mounted() {
    this.add_or_edit_modal = new Modal("#addOrEditModal");
  },
};
</script>

<template>
  <Layout>
    <PageHeader
      :dir="$i18n.locale == 'ar' ? 'rtl' : 'ltr'"
      :title="$t('menu.menuitems.tickets.text')"
    />

    <!-- Start search box -->
    <div class="row">
      <div class="col-6">
        <div class="search-box chat-search-box w-50">
          <div class="position-relative">
            <input
              @input="search(page)"
              type="search"
              class="form-control fa-lg text-light"
              :dir="$i18n.locale == 'ar' ? 'rtl' : 'ltr'"
              :placeholder="$t('popups.search')"
              v-model="searchModel"
              style="background-color: #2a3042 !important"
            />
            <i class="bx bx-search-alt search-icon text-light"></i>
          </div>
        </div>
      </div>
      <div class="col-6" style="display: flex; justify-content: flex-end">
        <button
          type="button"
          @click="preAddTicket()"
          class="btn btn-light float-end mb-4"
        >
          <span
            class="bx bxs-plus-circle float-end fa-2x"
            style="color: #2a3042 !important"
          ></span>
        </button>
      </div>
    </div>
    <!-- end search box -->

    <table :dir="$i18n.locale == 'ar' ? 'rtl' : 'ltr'" class="table">
      <thead>
        <tr
          class="text-light text-center"
          style="background-color: #2a3042 !important"
        >
          <th scope="col">#</th>
          <th scope="col">{{ $t("tickets.id") }}</th>
          <th scope="col">{{ $t("tickets.issuetype") }}</th>
          <th scope="col">{{ $t("tickets.customer") }}</th>
          <th scope="col">{{ $t("tickets.description") }}</th>
          <th scope="col">{{ $t("tickets.status") }}</th>
          <th scope="col">{{ $t("tickets.priority") }}</th>
          <th scope="col" style="width: 2%">{{ $t("tickets.created") }}</th>

          <th scope="col">{{ $t("tickets.operations") }}</th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="(searchIn, index) in tickets"
          :key="searchIn"
          class="text-center"
        >
          <td>{{ index + 1 }}</td>
          <td>{{ searchIn.id }}</td>
          <td>{{ searchIn.issue_type?.name }}</td>
          <td>
            {{
              searchIn?.customer?.name
                ? searchIn?.customer?.name
                : searchIn.customer_name
            }}
          </td>
          <td v-html="searchIn.description"></td>
          <td>
            <h6 v-if="!searchIn.status" class="text-danger">
              {{ $t("popups.underprogress") }}
            </h6>
            <span v-else class="text-success">{{ $t("popups.Finished") }}</span>
          </td>
          <td>
            <h6 v-if="searchIn.priority == 1" class="text-danger">
              {{ $t("popups.high") }}
            </h6>
            <span v-if="searchIn.priority == 2" class="text-warning">{{
              $t("popups.medium")
            }}</span>
            <h6 v-if="searchIn.priority == 3" class="text-success">
              {{ $t("popups.low") }}
            </h6>
          </td>
          <td>{{ searchIn?.created.split("T")[0] }}</td>

          <td class="d-flex justify-content-center">
            <button
              v-if="searchIn.remark === 0"
              @click="getSwitch(searchIn, 2)"
              class="btn btn-danger btn-sm me-2 mt-2"
            >
              {{ $t("popups.rejected") }}
            </button>
            <button
              v-if="searchIn.remark === 0"
              type="button"
              @click="getSwitch(searchIn, 1)"
              class="btn btn-success btn-sm me-2 mt-2"
            >
              {{ $t("popups.accepted") }}
            </button>
            <!-- <a
              class="btn btn-primary me-2"
              
              role="button"
              @click="gitresolution(searchIn)"
              >{{ $t("popups.resolutions") }}
            </a> -->
            <div v-if="searchIn.remark === 1">
              <button
                v-if="!searchIn.status"
                type="button"
                @click="closeTicket(searchIn)"
                class="btn btn-primary me-2"
              >
                {{ $t("popups.close_ticket") }}
              </button>
              <router-link
                class="btn btn-primary me-2"
                :to="{ name: 'ticketResolutions', params: { id: searchIn.id } }"
                role="button"
                >{{ $t("popups.resolutions") }}
              </router-link>
              <a
                class="btn btn-primary mt-1 me-2"
                @click="preEditTicket(searchIn)"
                href="javascript: void(0);"
                role="button"
                >{{ $t("popups.edit") }}</a
              >
              <a
                class="btn btn-danger mt-1 me-2"
                href="javascript: void(0);"
                role="button"
                @click="deleteTickets(searchIn)"
                >{{ $t("popups.delete") }}</a
              >
            </div>
            <a
              v-if="searchIn.remark === 2"
              class="btn btn-danger me-2"
              href="javascript: void(0);"
              role="button"
              @click="deleteTickets(searchIn)"
              >{{ $t("popups.delete") }}</a
            >
          </td>
        </tr>
      </tbody>
    </table>
    <!-- end  table -->
    <!-- Button trigger modal -->

    <!-- Modal -->

    <!--end-->
    <!--   Apps  Pagination     -->
    <div>
      <ul class="pagination pagination-rounded justify-content-center mb-2">
        <li class="page-item" :class="{ disabled: page == 1 }">
          <a
            class="page-link"
            href="javascript: void(0);"
            @click="get(page - 1)"
            aria-label="Previous"
          >
            <i class="mdi mdi-chevron-left"></i>
          </a>
        </li>
        <li
          class="page-item"
          :class="{ active: p == page }"
          v-for="p in tot_pages"
          :key="p"
        >
          <a class="page-link" href="javascript: void(0);" @click="get(p)">{{
            p
          }}</a>
        </li>

        <li class="page-item" :class="{ disabled: page == tot_pages }">
          <a
            class="page-link"
            href="javascript: void(0);"
            @click="get(page + 1)"
            aria-label="Next"
          >
            <i class="mdi mdi-chevron-right"></i>
          </a>
        </li>
      </ul>
    </div>
    <!--end-->
    <div
      class="modal fade"
      id="addOrEditModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="modelTitleId"
      aria-hidden="true"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">
              {{ editMode ? $t("popups.editticket") : $t("popups.addticket") }}
            </h5>
          </div>
          <form @submit.prevent="editMode ? editTicket() : addTicket()">
            <div class="modal-body">
              <div class="row">
                <div class="col-12 mb-3">
                  <label for="" class="form-label">{{
                    $t("popups.issuetype")
                  }}</label>
                  <select
                    class="form-select form-select-lg"
                    v-model="data.issue_type_id"
                  >
                    <option
                      :value="issue.id"
                      v-for="(issue, index) in issues"
                      :key="index"
                    >
                      {{ issue.name }}
                    </option>
                  </select>
                </div>
                <div class="col-12 mb-3">
                  <label class="form-label">{{ $t("popups.customer") }}</label>

                  <!-- Radio buttons to choose mode -->
                  <div class="mb-2">
                    <div class="form-check form-check-inline">
                      <input
                        class="form-check-input"
                        type="radio"
                        id="existingCustomer"
                        value="existing"
                        v-model="customerMode"
                      />
                      <label class="form-check-label" for="existingCustomer">{{
                        $t("popups.existingCustomer")
                      }}</label>
                    </div>
                    <div class="form-check form-check-inline">
                      <input
                        class="form-check-input"
                        type="radio"
                        id="newCustomer"
                        value="new"
                        v-model="customerMode"
                      />
                      <label class="form-check-label" for="newCustomer">{{
                        $t("popups.newCustomer")
                      }}</label>
                    </div>
                  </div>

                  <!-- AutoComplete for existing customer -->
                  <AutoComplete
                    v-if="customerMode === 'existing'"
                    required
                    v-model="data.customer"
                    :suggestions="customers"
                    @complete="searchCustomers($event.query)"
                    @item-select="data.customer_id = data.customer?.id"
                    :complete-on-focus="false"
                    :optionLabel="showEmpLabel"
                    :inputClass="'form-control'"
                    class="w-100"
                  />

                  <!-- Manual input for new customer -->
                  <input
                    v-if="customerMode === 'new'"
                    type="text"
                    class="form-control"
                    placeholder="Enter customer name"
                    v-model="newCustomerName"
                    @input="data.customer = { id: null, name: newCustomerName }"
                  />
                </div>
                <div class="col-12 mb-3">
                  <label for="" class="form-label">{{
                    $t("popups.priority")
                  }}</label>
                  <select
                    class="form-select form-select-lg"
                    v-model="data.priority"
                    required
                  >
                    <option value="1">{{ $t("popups.high") }}</option>
                    <option value="2">{{ $t("popups.medium") }}</option>
                    <option value="3">{{ $t("popups.low") }}</option>
                  </select>
                </div>

                <div class="col-12 mb-3">
                  <label for="" class="form-label">{{
                    $t("popups.des")
                  }}</label>
                  <ckeditor
                    :editor="editor"
                    v-model="data.description"
                    :config="editorConfig"
                  ></ckeditor>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button type="submit" class="btn btn-primary">
                {{ editMode ? $t("popups.edit") : $t("popups.add") }}
              </button>
              <button
                type="button"
                class="btn btn-secondary"
                data-dismiss="modal"
                @click="closeAddTicketModel()"
              >
                {{ $t("popups.colse") }}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </Layout>
</template>
<style scoped>
.close {
  position: relative;
  right: 317px;
  top: 6px;
  font-size: 15px;
}
</style>
